// Wrap window.location getter and setter and reload method in a module so we
// can readily mock it in tests
const getWindowLocation = () => window.location

const reloadWindowLocation = () => window.location.reload()

const setWindowLocation = (url) => {
  window.location = url
}

export { getWindowLocation, reloadWindowLocation, setWindowLocation }
